module.exports = __webpack_public_path__ + "media/images/client/AssistantChat/selection-914c0fb34dc2d105a500579cc391c43f.png";